import React from 'react';
import {FormattedMessage} from 'react-intl';
import Popover from '../../../components/popover/popover';
import InformationCircle from '../../../assets/icons/information-circle.svg';
import './order.scss';
import splitPrice from '../splitPrice';
import {isSet} from '../../../utility';
import Currency from '../../../components/currency/currency';

const PopoverContent = ({orderAmount, serviceFee, total}) => {
    return (
        <div className='text-xs'>
            {/* <p>
                <FormattedMessage defaultMessage='Order'/><span>{` - ${serviceFee ? orderAmount : total} `}</span><FormattedMessage defaultMessage='UAH'/>
            </p> */}
            <p><FormattedMessage defaultMessage='Services fee'/><span>{` - ${serviceFee || 0} `}</span><FormattedMessage defaultMessage='UAH'/></p>
        </div>
    )
}

const Order = ({total, serviceFee, amount, children, coupon, basis, discountAmount, isStemImpulse}) => {
    const splittedTotal = splitPrice(total);
    return (
        <div className='order-container padding-top-2rem'>
            <div className='divider border-bottom-color-gray-200'/>
            {children}
            <div className='padding-top-1dot5rem padding-bottom-1rem'>
                {(isSet(serviceFee) || isSet(coupon)) &&
                <div className='padding-bottom-1rem'>
                    <div className='display-flex justify-content-space-between align-items-center'>
                        <div className='text-sm color-gray-500'><FormattedMessage defaultMessage='Sum'/></div>
                        <div className='text-sm color-gray-500 display-flex align-items-center'>
                            <span className='padding-right-0dot125rem'>{basis}</span>
                            <Currency {...{defaultCurrency: <FormattedMessage defaultMessage='UAH'/>, isStem: isStemImpulse, stemIconClasses: 'display-block width-1rem height-1rem'}}/>
                        </div>
                        
                    </div>
                    {isSet(serviceFee) && 
                    <div className='padding-top-0dot5rem display-flex justify-content-space-between align-items-center'>
                        <div className='text-sm color-gray-500'><FormattedMessage defaultMessage='Services fee'/></div>
                        <div className='text-sm color-gray-500 display-flex align-items-center'>
                            <span className='padding-right-0dot125rem'>{serviceFee}</span>
                            <Currency {...{defaultCurrency: <FormattedMessage defaultMessage='UAH'/>, isStem: isStemImpulse, stemIconClasses: 'display-block width-1rem height-1rem'}}/>
                        </div>
                    </div>
                    }
                    {(isSet(coupon)) &&
                    <div className='padding-top-0dot5rem display-flex justify-content-space-between align-items-center'>
                        <div className='text-sm color-gray-500'><FormattedMessage defaultMessage='Coupon discount'/></div>
                        <div className='text-sm color-gray-500 display-flex align-items-center'>
                            <span className='padding-right-0dot125rem'>-{discountAmount}</span>
                            <Currency {...{defaultCurrency: <FormattedMessage defaultMessage='UAH'/>, isStem: isStemImpulse, stemIconClasses: 'display-block width-1rem height-1rem'}}/>
                        </div>
                    </div>
                    }
                </div>
                }
                <div className='display-flex'>
                    <p className='text-lg semibold color-gray-700 flex-1 padding-right-0dot625rem'>
                        <FormattedMessage defaultMessage='Total'/>
                    </p>
                    {/* <div className='display-flex'> */}
                        {/* <div>
                            <Popover {...{content: <PopoverContent {...{orderAmount: amount, serviceFee, total}}/>, size: 'md', position: {bottom: '2rem', left: '-5.3125rem'}, arrow: 'bottom-middle'}}>
                                <InformationCircle className='width-1dot25rem padding-top-0dot25rem information-circle-popover margin-right-0dot5rem'/>
                            </Popover>
                        </div> */}
                        <p className='text-lg semibold color-gray-700 display-flex align-items-baseline'>
                            <span>{splittedTotal.whole}.</span>
                            <span className='text-sm bold padding-right-0dot125rem'>{splittedTotal.fraction}</span>
                            <Currency {...{defaultCurrency: <FormattedMessage defaultMessage='UAH'/>, isStem: isStemImpulse, stemIconClasses: 'display-block width-1dot25rem height-1dot25rem align-self-center'}}/>
                        </p>
                    {/* </div> */}
                </div>
            </div>
        </div>
    )
};

export default React.memo(Order);